"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutThemeProvider = exports.DEFAULT_CONTENT_MEDIA_PADDINGS = exports.DEFAULT_CONTENT_MEDIA_MAX_WIDTHS = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponentsMedia = require("@schlagerkhan/styled-components-media");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_CONTENT_MEDIA_MAX_WIDTHS = {
  initial: 425,
  tablet: 600,
  laptop: 1024
};
exports.DEFAULT_CONTENT_MEDIA_MAX_WIDTHS = DEFAULT_CONTENT_MEDIA_MAX_WIDTHS;
var DEFAULT_CONTENT_MEDIA_PADDINGS = {
  initial: 16,
  tablet: 24,
  laptop: 48
};
exports.DEFAULT_CONTENT_MEDIA_PADDINGS = DEFAULT_CONTENT_MEDIA_PADDINGS;
var contentMediaPaddings = DEFAULT_CONTENT_MEDIA_PADDINGS;
var contentMediaMaxWidths = DEFAULT_CONTENT_MEDIA_MAX_WIDTHS;

var createTheme = function createTheme(theme) {
  return Object.assign({
    contentMediaPaddings: contentMediaPaddings,
    contentMediaMaxWidths: contentMediaMaxWidths
  }, theme);
};

var LayoutThemeProvider = function LayoutThemeProvider(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  var newTheme = createTheme(theme);
  return _react["default"].createElement(_styledComponentsMedia.MediaThemeProvider, _extends({
    theme: newTheme
  }, props));
};

exports.LayoutThemeProvider = LayoutThemeProvider;